/*
  Baci: product photos inside a carousel (homepage product lists on phones).
  - Swiping on a photo moves through that product's photos (the photo strip scrolls on its own;
    the outer product carousel moves when swiping on the title/price or the space between cards).
  - The small arrows step one photo at a time, never open the product, and hide at the first/last photo.
  - The dots under the photo follow along.
*/
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 749px)');
  var GAL = '.resource-list__carousel .card-gallery';

  function parts(g) {
    var sc = g && g.querySelector('slideshow-slides');
    if (!sc) return null;
    var slides = Array.prototype.filter.call(sc.querySelectorAll('slideshow-slide'), function (s) {
      return !s.hidden && s.offsetWidth > 0;
    });
    return slides.length ? { g: g, sc: sc, slides: slides } : null;
  }

  function currentIndex(p) {
    var left = p.sc.getBoundingClientRect().left;
    var best = 0, bestDist = Infinity;
    p.slides.forEach(function (s, i) {
      var d = Math.abs(s.getBoundingClientRect().left - left);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    return best;
  }

  function update(g) {
    var p = parts(g);
    if (!p) return;
    var i = currentIndex(p), last = p.slides.length - 1;
    var prev = g.querySelector('slideshow-arrows .slideshow-control--previous');
    var next = g.querySelector('slideshow-arrows .slideshow-control--next');
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= last;
    var dots = g.querySelectorAll('.baci-card-dots button');
    Array.prototype.forEach.call(dots, function (d, k) { d.setAttribute('aria-selected', String(k === i)); });
  }

  function go(g, step) {
    var p = parts(g);
    if (!p) return;
    var i = Math.max(0, Math.min(p.slides.length - 1, currentIndex(p) + step));
    var delta = p.slides[i].getBoundingClientRect().left - p.sc.getBoundingClientRect().left;
    p.sc.scrollTo({ left: p.sc.scrollLeft + delta, behavior: 'smooth' });
  }

  // Arrows: handle them here, before the theme or the product link sees the tap.
  document.addEventListener('click', function (e) {
    if (!mq.matches) return;
    var btn = e.target instanceof Element ? e.target.closest(GAL + ' slideshow-arrows button') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    go(btn.closest(GAL), btn.classList.contains('slideshow-control--previous') ? -1 : 1);
  }, true);

  // Keep arrows and dots in step with swipes.
  var pending = new Set();
  var raf = 0;
  document.addEventListener('scroll', function (e) {
    if (!mq.matches) return;
    var t = e.target;
    if (!(t instanceof Element) || t.tagName !== 'SLIDESHOW-SLIDES') return;
    var g = t.closest(GAL);
    if (!g) return;
    pending.add(g);
    if (!raf) raf = requestAnimationFrame(function () {
      raf = 0;
      pending.forEach(update);
      pending.clear();
    });
  }, { capture: true, passive: true });

  function init() {
    if (!mq.matches) return;
    document.querySelectorAll(GAL).forEach(update);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', init, { once: true });
})();
